import { render, staticRenderFns } from "./Review-Projects.vue?vue&type=template&id=8483de92"
import script from "./Review-Projects.vue?vue&type=script&lang=js"
export * from "./Review-Projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports